import { useNavigate, useLocation } from 'react-router-dom';
import { Compass, Heart, MessageCircle, User, Sparkles } from 'lucide-react';

const NAV = [
  { path: '/discover', icon: Compass, label: 'Discover' },
  { path: '/matches', icon: Heart, label: 'Matches' },
  { path: '/messages', icon: MessageCircle, label: 'Messages' },
  { path: '/likes', icon: Sparkles, label: 'Likes' },
  { path: '/profile', icon: User, label: 'Profile' },
];

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass-nav border-t border-[var(--hairline)]" data-testid="bottom-nav">
      <div className="max-w-lg mx-auto flex justify-around items-center h-[72px] px-2">
        {NAV.map(item => {
          const active = pathname === item.path || (item.path === '/matches' && pathname.startsWith('/chat/'));
          return (
            <button key={item.path} onClick={() => navigate(item.path)} data-testid={`nav-${item.label.toLowerCase()}`}
              className="relative flex flex-col items-center gap-1 px-3 py-2 transition-all duration-200 group flex-1 max-w-[80px]">
              {active && (
                <>
                  <div className="absolute -top-px left-1/2 -translate-x-1/2 w-8 h-0.5 brand-gradient rounded-full" />
                  <div className="absolute inset-0 -z-10 rounded-2xl bg-[rgba(185,28,28,0.05)]" />
                </>
              )}
              <item.icon size={20} strokeWidth={active ? 2.2 : 1.6} className={`transition-colors ${active ? 'text-[#B91C1C]' : 'text-[#8A8A93] group-hover:text-[#0F0F10]'}`} fill={active && item.label === 'Matches' ? 'currentColor' : 'none'} />
              <span className={`text-[10px] font-semibold tracking-wide transition-colors ${active ? 'text-[#B91C1C]' : 'text-[#8A8A93] group-hover:text-[#0F0F10]'}`}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
